import React, { FC } from 'react'
import { PromoProps } from './Promo.types'
import { ImageCompound } from '../../Compounds/src/ImageCompound'
import { BrandIcon } from '../../Compounds/src/BrandIconCompound'
import { VideoCompound } from '../../Compounds/src/VideoCompound'
import { LinkCompound } from '../../Compounds/src/LinkCompound'
import { RTECompound } from '../../Compounds/src/RTECompound'
import { getValueListBgColor } from '../../../utils/background-util'

export const Promo: FC<PromoProps> = props => {
  const { testId, content } = props

  if (!content) {
    return null
  }

  const {
    imageLocation,
    eyebrowImage,
    icon,
    image,
    eyebrowText,
    contentText,
    linkText,
    video,
    backgroundColor,
    centerMedia,
    verticalSpace,
    columnSize,
    sizeConstrained,
    brandExtension,
  } = content

  const bgColor = backgroundColor ? `${getValueListBgColor(backgroundColor)}` : ''
  const colSize = columnSize ? `u-size${columnSize}` : ''
  const verticalPadding = verticalSpace ?? ''
  const sizeConstrain = sizeConstrained ?? ''
  const centerMargin = !eyebrowImage?.src && !icon?.iconsDropdown ? 'contentMargin' : ''
  const getMediaContent = () => {
    if (video?.playlistId?.length) {
      return <VideoCompound {...video} />
    } else {
      return <ImageCompound {...image} />
    }
  }
  const mediaContent = (mediaContentVerticalAlignment: string = '') => {
    if (mediaContentVerticalAlignment && mediaContentVerticalAlignment === 'center') {
      return (
        <div className='u-sizeConstrained u-lg-flexAlignItemsCenter u-paddingVert2gu u-sm-paddingVert2gu u-lg-flex u-sizeFull'>
          {getMediaContent()}
        </div>
      )
    } else {
      return getMediaContent()
    }
  }

  return (
    <section className={`${verticalPadding} ${colSize} ${sizeConstrain} ${brandExtension}`}>
      <div
        className={`Promo ${bgColor} u-flex u-md-flex u-md-flexCol u-md-flexColReverse u-sm-flex u-sm-flexCol u-sm-flexColReverse ${
          imageLocation === 'left' ? 'u-flexRowReverse' : 'u-flexRow'
        }`}>
        <div
          className={`first-column u-size6of12 u-md-sizeFull u-sm-sizeFull u-paddingVert6gu u-paddingHoriz5gu ${centerMargin}`}
          data-testid={testId ? `${testId}-left-column` : null}>
          {eyebrowImage?.src && eyebrowImage?.src?.length > 0 ? (
            <ImageCompound {...eyebrowImage} />
          ) : (
            icon?.iconsDropdown?.length && <BrandIcon {...icon} />
          )}
          {eyebrowText && eyebrowText?.length > 0 && (
            <div className='u-paddingVert2gu u-textBold'>{eyebrowText}</div>
          )}
          {contentText?.content && (
            <div className='u-paddingBottom6gu'>
              <RTECompound {...contentText} />
            </div>
          )}
          {linkText?.text?.length && <LinkCompound {...linkText} />}
        </div>
        <div
          className='second-column u-lg-flex u-size6of12 u-md-sizeFull u-sm-sizeFull'
          data-testid={testId ? `${testId}-right-column` : null}>
          {mediaContent(centerMedia)}
        </div>
      </div>
    </section>
  )
}
